import { generatePath } from 'react-router-dom';
import { Check, TriangleAlert } from 'lucide-react';

import { ListAlerts } from '@/alerts/view/queries/list-alerts';
import { encode } from '@/hooks/useQueryState';
import { label } from '@/utils/format/label';

import { NewsItem, NewsItemDescription, NewsItemIcon } from '../news-item';
import { WhatsNewLink } from '../whats-new-link';

export function NewAlerts() {
  const { data: alerts } = ListAlerts.useQuery({
    filters: {
      changedSinceDays: 1,
      groupIds: [],
      alertStatusList: ['Warning', 'Critical'],
      alertTypeList: [],
    },
  });

  const nbNewAlerts = alerts?.length ?? 0;

  const path = generatePath('/alerts?filters=:filters', {
    // FIXME: Highly temporary, the perfect solution would be to get rid of useQueryState on /alerts page
    filters: encode({
      changedSinceDays: 1,
      groupIds: [],
      alertStatusList: ['Warning', 'Critical'],
    }),
  });

  if (nbNewAlerts === undefined) {
    return null;
  }

  return (
    <NewsItem data-testid="new-alerts">
      <NewsItemIcon>
        {nbNewAlerts ? (
          <TriangleAlert
            className="size-full text-orange-600"
            aria-hidden="true"
          />
        ) : (
          <Check className="size-full text-gray-400" aria-hidden="true" />
        )}
      </NewsItemIcon>
      <NewsItemDescription isCollapsible={false}>
        You've got{' '}
        <WhatsNewLink to={path}>
          {nbNewAlerts} new {label(['alert', 'alerts'], nbNewAlerts)}
        </WhatsNewLink>{' '}
        since yesterday
      </NewsItemDescription>
    </NewsItem>
  );
}
